import { aircraftQuery } from "@common/api/aircraft"
import type { AtlPageDetailPublic } from "@common/client"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { FLEET } from "@/routes/_layout/aircraft/-lib/search"
import { PageCreateForm } from "@/routes/_layout/aircraft_/$aircraftId/tech-log/-components/form/create-form"
import { PagePane } from "@/routes/_layout/aircraft_/$aircraftId/tech-log/-components/page-pane"
import { CLOSED_SCAN } from "@/routes/_layout/aircraft_/$aircraftId/tech-log/-components/source"

export const Route = createFileRoute("/_layout/tech-logs/new")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "atl_page:create", "/"),
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(aircraftQuery(FLEET)),
  component: NewTechLogPagePane,
})

function NewTechLogPagePane(): React.ReactElement {
  const { data: fleet } = useSuspenseQuery(aircraftQuery(FLEET))
  const navigate = useNavigate({ from: Route.fullPath })
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/tech-logs",
      search: (previous) => ({ ...previous, ...CLOSED_SCAN, wide: undefined }),
    })
  const create = (created: AtlPageDetailPublic) => {
    const aircraft = fleet.data.find(({ id }) => id === created.aircraft_id)
    showToast(
      `Created ${created.log_number}`,
      aircraft?.registration_no ?? "",
      "success",
    )
    void navigate({
      to: "/tech-logs/$pageId",
      params: { pageId: created.id },
      search: true,
      replace: true,
    })
  }

  return (
    <PagePane
      title="New tech log"
      page={undefined}
      stepper={undefined}
      onClose={close}
    >
      <PageCreateForm
        aircraftId={undefined}
        latest={undefined}
        onCreate={create}
        onCancel={close}
      />
    </PagePane>
  )
}
